module.exports = __webpack_public_path__ + "static/media/frame-c-arrow-right-blue.524ea42e.svg";